
import CoParentPage from '@/modules/parent/coparent-page'

const CoParent = () => {
    return <CoParentPage />
}

export default CoParent
